import React from 'react';

import { UploadedPhoto } from '../../prop-types';
import PhotoFilename from '../photo-filename';
import { PandaViewPreviewContainer } from '../panda-view-preview-container';
import { previewProps } from './preview-props';

/**
 * @param {object} props
 * @param {object} props.photo - Photo object to display.
 */
const OriginalPhoto = ({ photo }) => {
  return (
    <div className="duplicate-photos__photo duplicate-photos__original-photo">
      <PhotoFilename photo={photo} className="mb-0" />

      <div className="list-item__preview mb-0">
        <PandaViewPreviewContainer {...photo} {...previewProps(photo)} />
      </div>
    </div>
  );
};

OriginalPhoto.propTypes = {
  photo: UploadedPhoto.isRequired,
};

export { OriginalPhoto };
